import { render, staticRenderFns } from "./warehouse-checkbox.vue?vue&type=template&id=dc84ad54&"
import script from "./warehouse-checkbox.vue?vue&type=script&lang=js&"
export * from "./warehouse-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports